export const noscript = (content: string) => `<noscript>${content}</noscript>`
